<template>
	<v-modal>
		<template v-slot:header>
			<h1>Assign Instruction</h1>
		</template>
		<form class="wide" @submit.prevent="submit">
			<loader v-if="!formReady"/>
			<div v-else>
				<v-tabs class="tabs--switch" v-on:selectedTabChanged="(event) => tabChanged(event.selectedTab)">
					<v-tab id="assignee" label="Assignee">
						<fieldset>
							<div>
								<div class="sr-only">
									<legend><span>Assignee</span></legend>
								</div>
								<div class="input-group">
									<label><span>Team </span>
										<select v-model="form.data.assign.team" name="user">
											<option selected value="">—</option>
											<option
												v-for="(team, teamIndex) in form.options.teams" :key="teamIndex"
												:value="team.id"
												v-html="team.name"/>
										</select>
									</label>
									<label><span>Colleague </span>
										<select v-model="form.data.assign.user" name="user">
											<option selected value="">—</option>
											<option
												v-for="(colleague, colleagueIndex) in colleagues"
												:key="colleagueIndex"
												:value="colleague.id" v-html="$present('fullName', colleague.profile)"/>
										</select>
									</label>
								</div>
							</div>
						</fieldset>
					</v-tab>
					<v-tab id="myself" label="Myself">
						<div class="alert alert--info center">
							<p class="beta">The instruction will be assigned to you.</p>
							<p>Only you, or an administrator, will be able to update this instruction.</p>
						</div>
					</v-tab>
				</v-tabs>
				<!--				<fieldset v-if="otherInstructions.length" class="mt-2">-->
				<!--					<div>-->
				<!--						<div class="sr-only">-->
				<!--							<legend><span>Other Instructions</span></legend>-->
				<!--						</div>-->
				<!--						<div>-->
				<!--							<label-->
				<!--								v-for="(instruction, instructionIndex) in otherInstructions" :key="instructionIndex"-->
				<!--								class="checkbox"><span>Also assign the associated {{ instruction.service_variant }} </span>-->
				<!--								<input checked type="checkbox">-->
				<!--							</label>-->
				<!--						</div>-->
				<!--					</div>-->
				<!--				</fieldset>-->
			</div>
		</form>
		<template v-slot:footer>
			<ul class="actions actions--right">
				<li>
					<button
						:disabled="form.processing" class="button button--secondary"
						@click.prevent="$vmodal.close()">Cancel
					</button>
				</li>
				<li>
					<process-button
						:processing="form.processing" class="button button--primary" text="Assign Instruction"
						@click="assign"/>
				</li>
			</ul>
		</template>
	</v-modal>
</template>
<script>

export default {
	data() {
		return {
			formReady: false,
			form: this.newForm({
				assign: {
					team: "",
					user: "",
					myself: false,
				},
			}),
		};
	},

	watch: {
		team: function () {
			if (
				!this.form.data.assign.team ||
				!this.form.data.assign.user
			) {
				return;
			}

			if (!_.find(this.colleagues, user => user.id === this.form.data.assign.user)) {
				this.form.set("assign.user", "");
			}
		},
	},

	props: {
		instruction: {
			required: true,
			type: Object,
		},
		client: {
			required: true,
			type: Object,
		},
		instructionHeader: {
			required: true,
			type: Function,
		},
	},

	computed: {
		otherInstructions() {
			return _.filter(this.client.instructions, instruction => {
				return instruction.id !== this.instruction.id;
			});
		},
		team() {
			if (!this.form.data.assign.team) {
				return null;
			}

			return _.find(this.form.options.teams, team => team.id === this.form.data.assign.team);
		},
		colleagues() {
			if (!this.team) {
				return this.form.options.colleagues;
			}

			return this.team.all_members;
		},
	},

	methods: {
		tabChanged(tab) {
			this.form.reset();
			if (tab.id !== "myself") {
				return;
			}
			this.form.set("assign.user", this.$authed().id);
		},
		assign() {
			this.form.patch(this.route("instructions/:instruction/assign", this.instruction)).then(response => {
				this.$store.commit("instructions/UPDATE_ITEM", response.data);
				this.$store.dispatch("alertsStore/success", "Instruction Assigned");
				this.$vmodal.close();
			});
		},
	},

	created() {
		http().get("form-data/assign").then(response => {
			this.form.setOptions(response.data);
			this.formReady = true;
		});
	},
};
</script>
